import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authed/receipts')({
  component: ReceiptsRouteLayout,
});

function ReceiptsRouteLayout() {
  return <Outlet />;
}
